angular.module('picmonic-common').factory('ObjectUtils', function () {
  return {
    removeNulls: function (object) {
      return Object.fromEntries(Object.entries(object).filter(([_, value]) => value !== null));
    },
    removeEmpty: function (object) {
      return Object.entries(object).reduce((acc, [key, value]) => {
        const processed =
          typeof value === 'object' && !Array.isArray(value) && value !== null ? this.removeEmpty(value) : value;

        return processed !== '' &&
          processed !== undefined &&
          processed !== null &&
          !(Array.isArray(processed) && processed.length === 0)
          ? { ...acc, [key]: processed }
          : acc;
      }, {});
    },
  };
});
